import React from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import {  useHistory } from 'react-router-dom';

// Components
import Loading from '../components/Loading';
import StyledPageContent from '../components/StyledPage';
import Button from '../components/Button';
import SubTitulo from '../components/Subtitulo';


import AcreditacionProfile, { GET_PROFILE } from '../models/AcreditacionProfile';

//Assets
import iconEdit from '../assets/icons/edit.svg';

const StyledPage = styled(StyledPageContent)`
  .grid {
    display: grid;
    grid-template-columns: 136px 1fr 240px;
  }
  .photo-wrapper {
    .photo {
      font-size: 0;
      box-shadow: var(--base-box-shadow);
      margin-bottom: 1rem;
    }
    .name {
      font-size: 1.3rem;
      font-weight: var(--font-weight-medium);
      color: var(--color-secondary);
    }
  }
  .account-info-wrapper {
    position: relative;
    padding: 0 2rem;
    li {
      h4 {
        margin-bottom: .3rem;
      }
      &:not(:last-child) {
        margin-bottom: 1rem;
        border-bottom: 1px solid var(--color-gray-lighter);
        padding-bottom: 1rem;
      }
    }
  }
  .edit-button {
    position: absolute;
    top: 0;
    right: 2rem;
    display: inline-block;
    background-color: var(--color-secondary-btn);
    width: 32px;
    height: 32px;
    padding: 6px;
    border-radius: 9999px;
    &:hover {
      background-color: var(--color-secondary-btn);
    }
    &::after {
      display: inline-block;
      content: '';
      width: 100%;
      height: 100%;
      background-image: url(${iconEdit});
      background-repeat: no-repeat;
      background-size: contain;
      filter: var(--filter-white);
    }
  }
  .event-list-wrapper {
    border-left: 1px solid var(--color-gray-lighter);
    padding-left: 2rem;
    & > *:not(:last-child) {
      margin-bottom: 1.5rem;
    }
    li {
      &:not(:last-child) {
        margin-bottom: .3rem;
      }
    }
    a {
      color: var(--color-primary);
      &:hover {
        text-decoration: underline;
      }
    }
    h2 {
      font-size: 1.1rem;
      margin-bottom: .5rem;
    }
    .attach-file-button {
      font-size: 1rem !important;
    }
  }
`

export default  () => {
    let history = useHistory();
    let UserInfo=AcreditacionProfile.getProfile();
  
    const { loading, error, data } = useQuery(GET_PROFILE,{
        variables:{
            profile_uuid:UserInfo.uuid,
        }
    });

    if(loading)
        return <Loading />

    let profile=data.getAcreditacionProfile;

    return (
        <StyledPage>
            <SubTitulo>
                <h2>Mi cuenta</h2>
            </SubTitulo>          
            <p>Para tener tu información completa y tengas más oportunidad de participar en nuestras Experiencias Atleti, 
              te solicitamos completar los siguientes datos. Además, con esta información ganarás 30 puntos para tus 
              puntos Atleti.</p>
            <br />
            <br />
            <div className='grid'>
                <div className="photo-wrapper">
                    <div className="photo"><img src={profile.avatar_url} /></div>
                    <div className="name">{profile.name} {profile.last_name}</div>
                </div>
                <div className="account-info-wrapper">
                    <ul>
                        <li>
                            <h4>Email</h4>
                            <p>{profile.email}</p>
                        </li>
                        <li>
                            <h4>Teléfono celular</h4>
                            <p>{profile.tel_cell}</p>
                        </li>
                        <li>
                            <h4>Fecha de nacimiento</h4>
                            <p>{profile.birth_date}</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="page-footer" style={{textAlign:'center'}}>
                <br />
                <br />
                <br />
                <Button type='button' onClick={ () => history.push('micuenta-edit') } >Editar</Button>
            </div>

        </StyledPage>
    )
};